import get from 'lodash.get';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

export const selectLastAddedJobId = (state) => get(state, 'lastAddedJobId', '');
export const selectBulkCancelJobsByPusherJobGuid = (state, { pusherJobGuid }) => {
  const jobIdtoJobMap = get(state, 'jobIdtoJobMap', emptyObject);
  const pusherJobs = Object.keys(jobIdtoJobMap)
    .map((key) => jobIdtoJobMap[key])
    .filter((job) => get(job, 'pusherJobGuids', emptyArray).indexOf(pusherJobGuid) !== -1);

  if (pusherJobs.length === 0) {
    return emptyArray;
  }

  return pusherJobs;
};
